export default __webpack_public_path__ + "static/media/addIcon.e64346cd.svg";